<template>
  <!-- User Profile Address Edit Info Tab Content View From Account Profile -->
  <div>
    <div class="tabs-content-secondblock mb-7">
      <div class="row" v-if="ajaxCallinprogress">
        <div class="col-lg-12 py-5 px-3 mt-10">
          <div class="flex-container">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#005dae" />
          </div>
        </div>
      </div>
      <div class="row" v-if="!ajaxCallinprogress">
        <div class="col-lg-12">
          <div
            class="ml-2 mr-1"
            v-for="(address_field, index) in editAddressData.address"
            :key="index"
          >
            <div class="infoHeader mt-4 pb-4">
              <div class="d-flex justify-content-between align-items-center">
                <h6 class="subHeaderTitle ml-4">
                  {{address_field.value.address_type}}
                  <sup v-if="index > 0" class="fs-14 ml-1 mandatory">
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="The options for this field are configurable in the Settings page"
                      placement="right"
                    >
                      <i class="icon-information text-secondary" style="font-size: 14px"></i>
                    </el-tooltip>
                  </sup>
                </h6>
                <el-dropdown v-if="index > 0" trigger="click" :hide-on-click="true" style="width: auto">
                  <span class="el-dropdown-link mx-4">
                    <i class="el-icon-arrow-down el-icon--right" style="font-weight: 500; font-size: 20px;"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="item in addressTypes" :key="item" @click.native="address_field.value.address_type = item">{{item}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="a-q-Jc-j-editcontactView" v-if="index != 0">
                <div class="mt-3 mb-3 ml-4">
                  <label class="custom-control custom-checkbox digi-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      @input="duplicatePermanentAddress(index)"
                      :checked="boolDuplicateAddress.includes(index)"
                    />
                    <span class="custom-control-indicator"></span>
                    <span class="form-check-description fw-600">Same as Permanent Address</span>
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="d-flex justify-content-between align-items-center mt-1 px-3">
                    <div class="form-group gMap" style="position:relative;width:100%;">
                      <gmap-autocomplete
                        class="inputFieldNoBorder mt-0"
                        id="autocompleteInput"
                        name="get_location"
                        v-validate="'required'"
                        placeholder="Search Location"
                        @place_changed="setPlace($event,index)"
                        :value="address_field.value.location_vmodel"
                        v-model="address_field.value.location_vmodel"
                        style="padding: 8px 32px 8px 18px !important; height: 40px;"
                      ></gmap-autocomplete>
                      <img
                        src="/static/images/images-new-theme/icons/marker_pin.svg"
                        style="position: absolute;right: 12px;bottom: 10px;"
                      />
                    </div>
                    <div class="form-group gMap ml-4" style="cursor: pointer;" @click="getLocation(index)">
                      <img src="/static/images/images-new-theme/icons/gps.svg" style="height: 40px;" />
                    </div>
                  </div>

                  <div class="a-q-Jc-j-editcontactView">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Country</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView">
                          <multiselect
                            :max-height="200"
                            name="country"
                            class="digi-multiselect loaderbg mt-1"
                            v-model="address_field.value.country"
                            @input="address_field.value.state = '', address_field.value.city = '',address_field.value.street = '',address_field.value.township = '',address_field.value.zip_code = '',address_field.value.location_vmodel = ''"
                            :options="countries"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            data-vv-scope="userData"
                            placeholder="Select Country"
                            :disabled="boolDuplicateAddress.includes(index)"
                          >
                            <template slot="noOptions">
                                <div class="text-secondary text-center fw-600">List is Empty</div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Results Found</div>
                            </template>
                          </multiselect>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="a-q-Jc-j-editcontactView">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">State</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView">
                          <multiselect
                            :max-height="200"
                            name="country"
                            class="digi-multiselect loaderbg mt-1"
                            v-model="address_field.value.state"
                            @open="updateState(address_field.value.country)"
                            :options="states"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            :loading="isState"
                            data-vv-scope="userData"
                            :placeholder="address_field.value.country ? 'Select State' : 'Select Country to view States'"
                            :disabled="boolDuplicateAddress.includes(index)"
                          >
                            <template slot="noOptions">
                                <div class="text-secondary text-center fw-600">List is Empty</div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Results Found</div>
                            </template>
                          </multiselect>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="a-q-Jc-j-editcontactView">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">City</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView">
                          <input
                            class="inputField"
                            type="text"
                            name="city"
                            data-vv-scope="userData"
                            :maxlength="maxlengthaccounttownship"
                            data-vv-as="City"
                            v-model="address_field.value.city"
                            placeholder="Enter City"
                            oninput="this.value = this.value.toUpperCase()"
                            :disabled="boolDuplicateAddress.includes(index)"
                          />
                          <span
                            class="editcharacter-count text-grey"
                          >{{maxlengthaccounttownship - address_field.value.city.length}}/30</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="a-q-Jc-j-editcontactView mt-1">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Township</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView font-color">
                          <input
                            class="inputField"
                            type="text"
                            name="township"
                            data-vv-scope="userData"
                            :maxlength="maxlengthaccounttownship"
                            data-vv-as="Township"
                            v-model="address_field.value.township"
                            placeholder="Enter Township"
                            oninput="this.value = this.value.toUpperCase()"
                            :disabled="boolDuplicateAddress.includes(index)"
                          />
                          <span
                            class="editcharacter-count text-grey"
                          >{{maxlengthaccounttownship - address_field.value.township.length}}/30</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="a-q-Jc-j-editcontactView mt-1">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Street</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView font-color">
                          <input
                            class="inputField"
                            type="text"
                            data-vv-scope="userData"
                            name="street"
                            :maxlength="maxlengthaccountstreet"
                            v-model="address_field.value.street"
                            data-vv-as="Street"
                            placeholder="Enter Street"
                            oninput="this.value = this.value.toUpperCase()"
                            :disabled="boolDuplicateAddress.includes(index)"
                          />
                          <span
                            class="editcharacter-count text-grey"
                          >{{maxlengthaccountstreet - address_field.value.street.length}}/30</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="a-q-Jc-j-editcontactView">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Zip Code</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView text-runcate">
                          <input
                            class="inputField"
                            type="text"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            name="pin_code"
                            :maxlength="maxlengthaccountzipcode"
                            data-vv-scope="userData"
                            v-model="address_field.value.zip_code"
                            data-vv-as="Zip Code"
                            placeholder="Enter Zip Code"
                            :disabled="boolDuplicateAddress.includes(index)"
                          />
                          <span
                            class="editcharacter-count text-grey"
                          >{{maxlengthaccountzipcode - address_field.value.zip_code.length}}/30</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex justify-content-end mt-8 mr-2">
                    <button
                      type="button"
                      class="btn btn-new-primary btn-smm d-flex align-items-center mr-2"
                      style="box-shadow: none;"
                      v-if="address_field.value.city || address_field.value.country || address_field.value.state || address_field.value.street || address_field.value.township || address_field.value.zip_code"
                      @click="resetAddress(index)"
                    ><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset-icon.svg" style="width: 10px; height: 10px; margin-right: 6px;" /> Reset</button>
                    <button
                      type="button"
                      class="btn btn-new-danger btn-smm mr-2"
                      style="box-shadow: none;"
                      v-if="index!=0"
                      @click="deleteAddress"
                    >- Delete Address</button>
                    <button
                      type="button"
                      class="btn btn-new-green btn-smm"
                      style="box-shadow: none;"
                      v-if="index+1 == editAddressData.address.length"
                      @click="addAddress"
                    >+ Add Address</button>
                  </div>
                </div>
              </div>
            </div>
            <delete-address modal_name="deleteAddress" :address_type="address_field.value.address_type" :index="index" @addressDelete="addressDelete" @cancelDelete="cancelDelete"></delete-address>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { User } from "./mixins/user";
import countries from "./json/countries.json";
import { HalfCircleSpinner } from "epic-spinners";
import { EventBus } from "./eventBus/nav-bar-event.js";
import DeleteAddress from "./alertModals/DeleteAddress";
import axios from "axios";
export default {
  data() {
    return {
      maxlengthaccountzipcode: 30,
      maxlengthaccounttownship: 30,
      maxlengthaccountstreet: 30,
      permanentAddress: false,
      activatePermanentAddress: false,
      countries: countries,
      states: [],
      editAddressData: {},
      ajaxCallinprogress: false,
      requestResponse: false,
      userBasicInfo: {},
      address: {
        value: {
          street: "",
          city: "",
          township: "",
          state: "",
          country: "",
          zip_code: "",
          address_type: "Current Address",
          location_vmodel: ""
        },
        privacy: "contacts",
      },
      boolDuplicateAddress: [],
      addressTypes: [
        "Work Address",
        "Current Address",
        "Billing Address",
      ],
      addressIndex: 0,
      isState:false,
      isCountry:false
    };
  },
  mixins: [User],
  methods: {
    addAddress() {
      this.editAddressData.address.push({
        value: {
          street: "",
          city: "",
          township: "",
          state: "",
          country: "",
          address_type: "Current Address",
          zip_code: "",
        },
        privacy: "contacts",
      });
    },
    deleteAddress() {
      this.$modal.show("deleteAddress");
    },
    addressDelete(index) {
      this.boolDuplicateAddress = this.boolDuplicateAddress.filter(x => x != index);
      this.editAddressData.address.splice(index,1);
      this.$modal.hide("deleteAddress");
    },
    cancelDelete() {
      this.$modal.hide("deleteAddress");
    },
    resetAddress(index) {
      if (index === 0) {
        this.editAddressData.address[index].value = {
          street: "",
          city: "",
          township: "",
          state: "",
          country: "",
          zip_code: "",
          address_type: "Permanent Address (Billing Address)",
          location_vmodel: "",
        };
      } else {
        this.editAddressData.address[index].value = {
          street: "",
          city: "",
          township: "",
          state: "",
          country: "",
          zip_code: "",
          address_type: "Current Address",
          location_vmodel: ""
        };
      }
      if (this.boolDuplicateAddress.includes(index) && index != 0) {
        this.boolDuplicateAddress = this.boolDuplicateAddress.filter(x => x !== index);
      }
      this.$forceUpdate();
    },
    setPlace(place,index) {
      let currentPlace = place;
      let address = place.formatted_address.split(", ");
      this.editAddressData.address[index].value.street =
        address[address.length - 3] || "";
      this.editAddressData.address[index].value.township =
        address[address.length - 4] || "";
      this.editAddressData.address[index].value.city = currentPlace.vicinity;
      let statezip = address[address.length - 2]
        ? address[address.length - 2].split(" ")
        : ["", ""];
      if (statezip.length == 1) {
        if (statezip[0].match(/^[0-9]+$/)) {
          this.editAddressData.address[index].value.zip_code = statezip[0];
        } else {
          this.editAddressData.address[index].value.state = statezip[0];
        }
      } else {
        this.editAddressData.address[index].value.zip_code = statezip[0].match(/^[0-9]+$/)
          ? statezip[0]
          : statezip[1].match(/^[0-9]+$/)
          ? statezip[1]
          : "";
        this.editAddressData.address[index].value.state = statezip[0].match(/^[a-zA-Z]+$/)
          ? statezip[0]
          : statezip[1].match(/^[a-zA-Z]+$/)
          ? statezip[1]
          : "";
      }
      if (address[address.length - 1].includes("-")) {
        let countrySelected = address[address.length - 1].split(" - ");
        countrySelected.forEach(x => {
          if (this.countries.includes(x)) {
            this.editAddressData.address[index].value.country = x;
          } else {
            this.editAddressData.address[index].value.country = "";
          }
        });
      } else {
        this.editAddressData.address[index].value.country = address[address.length - 1];
      }
      // this.editAddressData.address[index].address.latitude = currentPlace.geometry.location.lat() || "";
      // this.editAddressData.address[index].address.longitude = currentPlace.geometry.location.lng() || "";
      this.editAddressData.address[index].value.location_vmodel = place.formatted_address;
      this.$forceUpdate();
    },
    getLocation(index) {
      this.addressIndex = index;
      if (navigator.geolocation) {
        // timeout at 60000 milliseconds (60 seconds)
        var options = {
          enableHighAccuracy: false,
          timeout: 30000, // milliseconds (30 seconds)
          maximumAge: 600000
        }; // milliseconds (10 minutes)
        navigator.geolocation.getCurrentPosition(
          this.showLocation,
          this.errorHandler,
          options
        );
      } else {
        alert("Sorry, browser does not support geolocation!");
      }
    },
    showLocation(position) {
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      let latlongvalue = position.coords.latitude + "," + position.coords.longitude;
      let calllatlong = axios.create();
      delete calllatlong.defaults.headers.common['Authorization'];
      calllatlong.post("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + latlongvalue + "&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY")
      .then(response => {
        let address = response.data.results[0].formatted_address.split(", ");
        this.editAddressData.address[this.addressIndex].value.street =
          address[address.length - 6] || "";
        this.editAddressData.address[this.addressIndex].value.township =
          address[address.length - 4] || "";
        this.editAddressData.address[this.addressIndex].value.city = address[address.length - 3] || "";
        let statezip = address[address.length - 2]
          ? address[address.length - 2].split(" ")
          : ["", ""];
        this.editAddressData.address[this.addressIndex].value.zip_code = statezip[0].match(/^[0-9]+$/)
          ? statezip[0]
          : statezip[1].match(/^[0-9]+$/)
          ? statezip[1]
          : "";
        this.editAddressData.address[this.addressIndex].value.state = statezip[0].match(/^[a-zA-Z]+$/)
          ? statezip[0]
          : statezip[1].match(/^[a-zA-Z]+$/)
          ? statezip[1]
          : "";
        if (address[address.length - 1].includes("-")) {
          let countrySelected = address[address.length - 1].split(" - ");
          countrySelected.forEach(x => {
            if (this.countries.includes(x)) {
              this.editAddressData.address[this.addressIndex].value.country = x;
            } else {
              this.editAddressData.address[this.addressIndex].value.country = "";
            }
          });
        } else {
          this.editAddressData.address[this.addressIndex].value.country = address[address.length - 1];
        }
        this.editAddressData.address[this.addressIndex].value.location_vmodel = response.data.results[0].formatted_address;
        this.$forceUpdate();
      })
      .catch(e => {
        // this.errors.push(e)
      });
    },
    errorHandler(err) {
      if (err.code == 1) {
        // alert("Error: Access is denied!");
      } else if (err.code == 2) {
        // alert("Error: Position is unavailable!");
      }
    },
    duplicatePermanentAddress(index) {
      if (this.boolDuplicateAddress.includes(index)) {
        this.boolDuplicateAddress = this.boolDuplicateAddress.filter(x => x !== index);
        this.editAddressData.address[index].value = {
          street: "",
          city: "",
          township: "",
          state: "",
          country: "",
          zip_code: "",
          address_type: "Current Address",
          location_vmodel: ""
        };
      } else {
        this.boolDuplicateAddress.push(index);
        this.editAddressData.address[index].value.city = this.editAddressData.address[0].value.city;
        this.editAddressData.address[index].value.country = this.editAddressData.address[0].value.country;
        this.editAddressData.address[index].value.location_vmodel = this.editAddressData.address[0].value.location_vmodel;
        this.editAddressData.address[index].value.state = this.editAddressData.address[0].value.state;
        this.editAddressData.address[index].value.street = this.editAddressData.address[0].value.street;
        this.editAddressData.address[index].value.township = this.editAddressData.address[0].value.township;
        this.editAddressData.address[index].value.zip_code = this.editAddressData.address[0].value.zip_code;
      }
    },
    updateContactAddress() {
      this.editAddressData.address.forEach(x => {
        if (!x.value.city && !x.value.country && !x.value.state && !x.value.street && !x.value.township && !x.value.zip_code) {
          this.editAddressData.address = this.editAddressData.address.filter(i => i != x);
        } else {
          delete x.value["location_vmodel"];
        }
      });
      this.saveEditUser(this.editAddressData);
      this.$emit("updateUserData");
    },
    GetUserDetails(id) {
      this.ajaxCallinprogress = true;
      this.$http
        .post("/users/get_user_data", { user_id: id })
        .then(response => {
          if (response.data.status_id == 1) {
            this.userBasicInfo = response.data.response;
            this.editAddressData = JSON.parse(
              JSON.stringify(this.userBasicInfo)
            );
            if (!("address") in this.editAddressData) {
              Object.assign(this.editAddressData, {
                address: [
                  {
                    value: {
                      street: "",
                      city: "",
                      township: "",
                      state: "",
                      country: "",
                      zip_code: "",
                      address_type: "Current Address",
                      location_vmodel: "",
                    },
                    privacy: "contacts",
                  }
                ]
              });
            } else if (!(this.editAddressData.address.length)) {
              this.editAddressData.address = [
                {
                  value: {
                    street: "",
                    city: "",
                    township: "",
                    state: "",
                    country: "",
                    zip_code: "",
                    address_type: "Current Address",
                    location_vmodel: "",
                  },
                  privacy: "contacts",
                }
              ];
            }
            this.editAddressData.address.forEach(x => {
              if (!("state" in x.value)) {
                Object.assign(x.value, {
                  state: "",
                });
              }
              if (!("city" in x.value)) {
                Object.assign(x.value, {
                  city: "",
                });
              }
              if (!("street" in x.value)) {
                Object.assign(x.value, {
                  street: "",
                });
              }
              if (!("zip_code" in x.value)) {
                Object.assign(x.value, {
                  zip_code: "",
                });
              }
              if (!("township" in x.value)) {
                Object.assign(x.value, {
                  township: "",
                });
              }
              if (!("location_vmodel" in x.value)) {
                Object.assign(x.value, {
                  location_vmodel: "",
                });
              }
            });
            for (let i = 1; i < this.editAddressData.address.length; i++) {
              let addressSelected = this.editAddressData.address[i];
              if (addressSelected.value.zip_code == this.editAddressData.address[0].value.zip_code && addressSelected.value.township == this.editAddressData.address[0].value.township && addressSelected.value.street == this.editAddressData.address[0].value.street && addressSelected.value.state == this.editAddressData.address[0].value.state && addressSelected.value.country == this.editAddressData.address[0].value.country && addressSelected.value.city == this.editAddressData.address[0].value.city) {
                this.boolDuplicateAddress.push(i);
              }
            };
            if (this.editAddressData.address[0].value.address_type != "Permanent Address (Billing Address)") {
              this.editAddressData.address[0].value.address_type = "Permanent Address (Billing Address)";
            }
            this.ajaxCallinprogress = false;
          }
        })
        .catch(error => {
        });
    },
    updateState(country) {
      this.isState = true
      this.states = [];
      if (country) {
        let params = {
          country_required: false,
          state_required: true,
          country_name: country,
        };
        this.$http.post("/location/get_location", params).then(res => {
          if (res.data.status_id == 1 && "all_states" in res.data.response) {
            res.data.response.all_states.forEach(x => {
              this.states.push(x);
            });
            this.isState = false
          }
        });
      }
    },
  },
  components: {
    HalfCircleSpinner,
    DeleteAddress,
  },
  mounted() {
    EventBus.$on("addressInformation", () => {
      this.updateContactAddress();
    });
    EventBus.$on("hideuser", () => {
      this.hideEdit();
    });
  },
  created() {
    if (this.$route.params.id) {
      this.GetUserDetails(this.$route.params.id);
    } else {
      this.GetUserDetails(this.loggedInUser._id);
    }
  },
  destroyed() {
    EventBus.$off("addressInformation");
    EventBus.$off("hideuser");
  },
  computed: {
    loggedInUser() {
      return this.$store.getters.loggedInUser;
    },
    account() {
      return this.$store.getters.account;
    },
  },
};
</script>
<style>
.socialMedia.dropdown-toggle::after {
  margin-left: 5px;
}

@-moz-document url-prefix() {
  .inputMedia {
    padding-right: 26px !important;
  }
}
.mediaDropdown.dropdown-menu {
  margin: 0rem 0rem 0 !important;
}
.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__content
  .el-tab-pane
  .tabs-content-firstblock {
  border-radius: 5px;
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #cdd2da;
  background-color: #ffffff;
  margin: 5px 10px 15px;
}
.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__content
  .el-tab-pane
  .tabs-content-secondblock {
  border-radius: 5px;
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #cdd2da;
  background-color: #ffffff;
  margin: 5px 10px 15px;
}
textarea.textarea-control {
  height: auto;
}

textarea.textarea-control {
  display: block;
  width: 100%;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #4e5764;
  background-color: #fff;
  background-image: none;
  border: 1px solid #cdd2da;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
}
.input-group.digi-input-group {
  border: 1px solid #cdd2da !important;
}
.input-group.digi-input-group > .form-control {
  position: relative !important;
  -webkit-box-flex: 1 !important;
  -webkit-flex: 1 1 auto !important;
  -ms-flex: 1 1 auto !important;
  flex: 1 1 auto !important;
  width: 1% !important;
  margin-bottom: 0 !important;
  height: 22px !important;
  padding: 6px 12px 6px 2px !important;
  color: #4e5764;
  text-decoration: underline;
  border-bottom: 1px solid transparent !important;
}
.input-group.digi-input-group .input-group-addon {
  padding-left: 0rem !important;
  padding-right: 0.2rem !important;
  border-bottom: 1px solid transparent !important;
  padding-top: 2px;
  cursor: pointer;
}
.qrcode-block-view-account {
  border-radius: 6px;
  width: 104px;
  height: 105px;
  position: relative;
  display: inline-block;
  display: block;
  border: 1px solid #005dae;
  background: #d6e2ef;
}
.qrcode-content-view-account {
  text-align: center;
  margin: 6px auto;
  background: #d6e2ef !important;
}
.qr-logo-view-account {
  position: absolute;
  margin-top: 40px;
  margin-left: 35px;
  width: 30px;
}
.removeBlocks {
  right: 20px;
  margin-right: 2px;
}
.removeBlocksPhone {
  right: 18px;
  margin-right: 2px;
}
.removeBlocksPhone.removedAddPhone {
  right: 0px;
  margin-right: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/EditContactAddressView.vue